export default {
  metrics: [{ "id": 1, "name": "Time to receive Imps", "type": "State Transition", "propertyName": null, "caseTypeId": 105, "bucketId": null, "baseMetricId": null, "functionName": null, "createdAt": "2021-07-27T13:38:24.000Z", "updatedAt": "2021-07-27T13:38:24.000Z", "lastranAt": "2021-08-12T14:02:00.000Z", "groupBy": null, "intermediateStateIds": [407, 432, 433, 408, 409], __typename: "Metric" }, { "id": 2, "name": "Avg time to receive imps", "type": "Bucket", "propertyName": null, "caseTypeId": 105, "bucketId": 1754, "baseMetricId": 1, "functionName": "avg", "createdAt": "2021-07-27T13:41:43.000Z", "updatedAt": "2021-07-27T13:41:43.000Z", "lastranAt": "2021-08-12T14:02:00.000Z", "groupBy": null, "intermediateStateIds": [], __typename: "Metric" }, { "id": 5, "name": "Median time to receive imps", "type": "Bucket", "propertyName": null, "caseTypeId": 105, "bucketId": 1754, "baseMetricId": 1, "functionName": "median", "createdAt": "2021-07-28T07:36:30.000Z", "updatedAt": "2021-07-28T07:36:30.000Z", "lastranAt": "2021-08-12T14:02:00.000Z", "groupBy": null, "intermediateStateIds": [], __typename: "Metric" }, { "id": 6, "name": "Time to produce + ship", "type": "State Transition", "propertyName": null, "caseTypeId": 105, "bucketId": null, "baseMetricId": null, "functionName": null, "createdAt": "2021-07-28T08:51:50.000Z", "updatedAt": "2021-07-28T08:51:50.000Z", "lastranAt": "2021-08-12T14:02:00.000Z", "groupBy": null, "intermediateStateIds": [409, 416, 417, 418], __typename: "Metric" }, { "id": 7, "name": "Avg time to product + ship", "type": "Bucket", "propertyName": null, "caseTypeId": 105, "bucketId": 1755, "baseMetricId": 6, "functionName": "avg", "createdAt": "2021-07-28T08:52:23.000Z", "updatedAt": "2021-07-28T08:52:23.000Z", "lastranAt": "2021-08-12T14:02:00.000Z", "groupBy": null, "intermediateStateIds": [], __typename: "Metric" }, { "id": 8, "name": "Order Value", "type": "Case Property", "propertyName": "order_total", "caseTypeId": 105, "bucketId": null, "baseMetricId": null, "functionName": null, "createdAt": "2021-07-29T14:33:18.000Z", "updatedAt": "2021-07-29T14:33:18.000Z", "lastranAt": "2021-08-12T14:02:00.000Z", "groupBy": null, "intermediateStateIds": [], __typename: "Metric" }, { "id": 9, "name": "Daily Order Value", "type": "Bucket", "propertyName": null, "caseTypeId": 105, "bucketId": 1756, "baseMetricId": 8, "functionName": "sum", "createdAt": "2021-07-29T16:23:21.000Z", "updatedAt": "2021-07-29T16:23:21.000Z", "lastranAt": "2021-08-12T14:02:00.000Z", "groupBy": null, "intermediateStateIds": [], __typename: "Metric" }, { "id": 10, "name": "Daily No. of Orders", "type": "Bucket", "propertyName": null, "caseTypeId": 105, "bucketId": 1756, "baseMetricId": 8, "functionName": "count", "createdAt": "2021-07-30T11:43:40.000Z", "updatedAt": "2021-07-30T11:43:40.000Z", "lastranAt": "2021-08-12T14:02:00.000Z", "groupBy": null, "intermediateStateIds": [], __typename: "Metric" }, { "id": 11, "name": "Avg Order Value", "type": "Bucket", "propertyName": null, "caseTypeId": 105, "bucketId": 1756, "baseMetricId": 8, "functionName": "avg", "createdAt": "2021-07-30T11:44:50.000Z", "updatedAt": "2021-07-30T11:44:50.000Z", "lastranAt": "2021-08-12T14:02:00.000Z", "groupBy": null, "intermediateStateIds": [], __typename: "Metric" }, { "id": 14, "name": "Order Val by Priority", "type": "Bucket", "propertyName": null, "caseTypeId": 105, "bucketId": 1756, "baseMetricId": 8, "functionName": "sum", "createdAt": "2021-07-30T13:33:44.000Z", "updatedAt": "2021-07-30T13:33:44.000Z", "lastranAt": "2021-08-12T14:02:00.000Z", "groupBy": "priority", "intermediateStateIds": [], __typename: "Metric" }],
  widgetsAndOptions1: { "widget": { "id": 9, "metricId": 14, "metric": { "id": 14, "name": "Order Val by Priority", "type": "Bucket", "propertyName": null, "caseTypeId": 105, "bucketId": 1756, "baseMetricId": 8, "functionName": "sum", "createdAt": "2021-07-30T13:33:44.000Z", "updatedAt": "2021-07-30T13:33:44.000Z", "lastranAt": "2021-08-12T14:08:00.000Z", "groupBy": "priority", "intermediateStateIds": null, "bucketMeasurements": [{ "measurement": 380, "createdAt": "2021-08-09T12:48:01.000Z", "group": "General", __typename: "BucketMeasurement" }, { "measurement": 0, "createdAt": "2021-08-09T12:51:01.000Z", "group": "Urgent 48 Hr", __typename: "BucketMeasurement" }, { "measurement": 2350, "createdAt": "2021-08-09T12:52:01.000Z", "group": "Urgent 48 Hr", __typename: "BucketMeasurement" }, { "measurement": 0, "createdAt": "2021-08-09T12:53:01.000Z", "group": "Urgent 5 Day", __typename: "BucketMeasurement" }, { "measurement": 3500, "createdAt": "2021-08-09T12:54:01.000Z", "group": "Urgent 5 Day", __typename: "BucketMeasurement" }, { "measurement": 350, "createdAt": "2021-08-10T09:22:03.000Z", "group": "General", __typename: "BucketMeasurement" }, { "measurement": 1900, "createdAt": "2021-08-10T09:22:03.000Z", "group": "Urgent 48 Hr", __typename: "BucketMeasurement" }, { "measurement": 2500, "createdAt": "2021-08-12T13:04:01.000Z", "group": "General", __typename: "BucketMeasurement" }, { "measurement": 855, "createdAt": "2021-08-12T13:05:01.000Z", "group": "Urgent 48 Hr", __typename: "BucketMeasurement" }, { "measurement": 250, "createdAt": "2021-08-12T13:10:01.000Z", "group": "Urgent 5 Day", __typename: "BucketMeasurement" }], __typename: "Metric" }, "type": "piechart", "style": "white", "scale": 0, "prefix": null, "suffix": null, __typename: "Widget" }, "options": { "currencySymbol": "£" } },
  widgetsAndOptions2: { "widget": { "id": 12, "metricId": 11, "metric": { "id": 11, "name": "Avg Order Value", "type": "Bucket", "propertyName": null, "caseTypeId": 105, "bucketId": 1756, "baseMetricId": 8, "functionName": "avg", "createdAt": "2021-07-30T11:44:50.000Z", "updatedAt": "2021-07-30T11:44:50.000Z", "lastranAt": "2021-08-12T14:08:00.000Z", "groupBy": null, "intermediateStateIds": null, "bucketMeasurements": [{ "measurement": 89.49625, "createdAt": "2021-02-11T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 122.475, "createdAt": "2021-02-12T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 69, "createdAt": "2021-02-13T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 119.36363636363636, "createdAt": "2021-02-15T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 133.05882352941177, "createdAt": "2021-02-16T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 126.57142857142857, "createdAt": "2021-02-17T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 214.8, "createdAt": "2021-02-18T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 79.33333333333333, "createdAt": "2021-02-19T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 99, "createdAt": "2021-02-20T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 127.5, "createdAt": "2021-02-21T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 120.03333333333333, "createdAt": "2021-02-22T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 93.36363636363636, "createdAt": "2021-02-23T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 131.15, "createdAt": "2021-02-24T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 142.6, "createdAt": "2021-02-25T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 160.70454545454547, "createdAt": "2021-02-26T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 96.5, "createdAt": "2021-02-27T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 100.7475, "createdAt": "2021-02-28T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 215.16666666666666, "createdAt": "2021-03-01T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 128.94444444444446, "createdAt": "2021-03-02T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 77.33111111111111, "createdAt": "2021-03-03T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 182.33333333333334, "createdAt": "2021-03-04T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 169.375, "createdAt": "2021-03-05T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 125, "createdAt": "2021-03-06T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 113.49875, "createdAt": "2021-03-07T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 108.79, "createdAt": "2021-03-08T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 195.54166666666666, "createdAt": "2021-03-09T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 112.65, "createdAt": "2021-03-10T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 131.66666666666666, "createdAt": "2021-03-11T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 108.5, "createdAt": "2021-03-12T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 68, "createdAt": "2021-03-13T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 104.43, "createdAt": "2021-03-14T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 125, "createdAt": "2021-03-15T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 128.0909090909091, "createdAt": "2021-03-16T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 168, "createdAt": "2021-03-17T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 121.2075, "createdAt": "2021-03-18T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 129.14583333333334, "createdAt": "2021-03-19T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 165.9, "createdAt": "2021-03-20T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 117.5, "createdAt": "2021-03-21T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 224.24875, "createdAt": "2021-03-22T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 99.16666666666667, "createdAt": "2021-03-23T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 137.22222222222223, "createdAt": "2021-03-24T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 197.5, "createdAt": "2021-03-25T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 200.29166666666666, "createdAt": "2021-03-26T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 155.33166666666668, "createdAt": "2021-03-27T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 183.3, "createdAt": "2021-03-28T00:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 65.45363636363636, "createdAt": "2021-03-28T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 71.25, "createdAt": "2021-03-29T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 106.95363636363636, "createdAt": "2021-03-30T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 133.95, "createdAt": "2021-03-31T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 161.66666666666666, "createdAt": "2021-04-01T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 124.2, "createdAt": "2021-04-02T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 13.495000000000001, "createdAt": "2021-04-03T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 170.66666666666666, "createdAt": "2021-04-04T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 146.65, "createdAt": "2021-04-05T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 117.85, "createdAt": "2021-04-06T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 113.22454545454546, "createdAt": "2021-04-07T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 107.65, "createdAt": "2021-04-08T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 110.66333333333334, "createdAt": "2021-04-09T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 106.33, "createdAt": "2021-04-10T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 110.15, "createdAt": "2021-04-11T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 77.22636363636364, "createdAt": "2021-04-12T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 134.85714285714286, "createdAt": "2021-04-13T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 135.4, "createdAt": "2021-04-14T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 85.298, "createdAt": "2021-04-15T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 162.5, "createdAt": "2021-04-16T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 9.99, "createdAt": "2021-04-17T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 155.34615384615384, "createdAt": "2021-04-18T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 119.2, "createdAt": "2021-04-19T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 152.71285714285713, "createdAt": "2021-04-20T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 186.25, "createdAt": "2021-04-21T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 135, "createdAt": "2021-04-22T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 155.29592592592593, "createdAt": "2021-04-25T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 135.59949999999998, "createdAt": "2021-04-26T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 73.5, "createdAt": "2021-04-27T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 156, "createdAt": "2021-04-28T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 176.66666666666666, "createdAt": "2021-04-29T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 187.83666666666667, "createdAt": "2021-04-30T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 89.57000000000001, "createdAt": "2021-05-02T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 106.25, "createdAt": "2021-05-03T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 125.4375, "createdAt": "2021-05-04T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 119.38307692307693, "createdAt": "2021-05-05T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 80, "createdAt": "2021-05-06T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 101.125, "createdAt": "2021-05-07T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 126.25, "createdAt": "2021-05-08T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 170, "createdAt": "2021-05-09T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 121.63545454545455, "createdAt": "2021-05-10T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 197.11111111111111, "createdAt": "2021-05-11T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 181.0625, "createdAt": "2021-05-12T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 213.9375, "createdAt": "2021-05-13T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 113.398, "createdAt": "2021-05-14T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 124.125, "createdAt": "2021-05-15T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 120.21875, "createdAt": "2021-05-16T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 91.13636363636364, "createdAt": "2021-05-17T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 157.5, "createdAt": "2021-05-18T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 91.42857142857143, "createdAt": "2021-05-19T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 136.88888888888889, "createdAt": "2021-05-20T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 140, "createdAt": "2021-05-21T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 75.99600000000001, "createdAt": "2021-05-22T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 134.71428571428572, "createdAt": "2021-05-23T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 141.63636363636363, "createdAt": "2021-05-24T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 146.66666666666666, "createdAt": "2021-05-25T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 138.4988888888889, "createdAt": "2021-05-26T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 96.54545454545455, "createdAt": "2021-05-27T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 115, "createdAt": "2021-05-28T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 76.66666666666667, "createdAt": "2021-05-30T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 73.81125, "createdAt": "2021-05-31T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 112.61461538461539, "createdAt": "2021-06-01T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 158.87375, "createdAt": "2021-06-02T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 190.925, "createdAt": "2021-06-03T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 70, "createdAt": "2021-06-04T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 95.66333333333334, "createdAt": "2021-06-05T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 142.1818181818182, "createdAt": "2021-06-06T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 199.44333333333333, "createdAt": "2021-06-07T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 87.499375, "createdAt": "2021-06-08T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 203, "createdAt": "2021-06-09T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 182.14285714285714, "createdAt": "2021-06-10T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 128.125, "createdAt": "2021-06-11T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 139.7, "createdAt": "2021-06-12T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 163.91666666666666, "createdAt": "2021-06-13T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 131.8557142857143, "createdAt": "2021-06-14T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 97.6, "createdAt": "2021-06-15T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 113.85571428571428, "createdAt": "2021-06-16T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 120, "createdAt": "2021-06-17T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 136.875, "createdAt": "2021-06-18T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 110.14142857142858, "createdAt": "2021-06-19T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 214.28571428571428, "createdAt": "2021-06-20T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 113.16666666666667, "createdAt": "2021-06-21T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 152.94444444444446, "createdAt": "2021-06-22T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 114.8725, "createdAt": "2021-06-23T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 119.75, "createdAt": "2021-06-24T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 161.22222222222223, "createdAt": "2021-06-25T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 90, "createdAt": "2021-06-26T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 160.75, "createdAt": "2021-06-27T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 129.44444444444446, "createdAt": "2021-06-28T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 200.16666666666666, "createdAt": "2021-06-29T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 175.99857142857144, "createdAt": "2021-06-30T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 120.1809090909091, "createdAt": "2021-07-01T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 116.85714285714286, "createdAt": "2021-07-02T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 66.296, "createdAt": "2021-07-03T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 80.60777777777778, "createdAt": "2021-07-04T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 147.75, "createdAt": "2021-07-05T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 145.4, "createdAt": "2021-07-06T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 160.83333333333334, "createdAt": "2021-07-07T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 120.32142857142857, "createdAt": "2021-07-08T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 69.5, "createdAt": "2021-07-09T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 101.66666666666667, "createdAt": "2021-07-10T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 102.99909090909091, "createdAt": "2021-07-11T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 203.75, "createdAt": "2021-07-12T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 129.66666666666666, "createdAt": "2021-07-13T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 95.71428571428571, "createdAt": "2021-07-14T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 63.495000000000005, "createdAt": "2021-07-15T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 184.398, "createdAt": "2021-07-16T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 208.33333333333334, "createdAt": "2021-07-17T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 155.75, "createdAt": "2021-07-18T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 121.3325, "createdAt": "2021-07-19T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 160.83333333333334, "createdAt": "2021-07-20T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 123, "createdAt": "2021-07-21T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 173.33333333333334, "createdAt": "2021-07-22T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 335, "createdAt": "2021-07-23T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 136.699, "createdAt": "2021-07-24T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 124.52449999999999, "createdAt": "2021-07-25T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 90, "createdAt": "2021-07-26T23:00:00.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 0, "createdAt": "2021-08-09T12:40:02.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 126.66666666666667, "createdAt": "2021-08-09T12:48:01.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 63.333333333333336, "createdAt": "2021-08-09T12:51:01.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 682.5, "createdAt": "2021-08-09T12:52:01.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 390, "createdAt": "2021-08-09T12:53:01.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 1246, "createdAt": "2021-08-09T12:54:01.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 375, "createdAt": "2021-08-10T09:22:03.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 0, "createdAt": "2021-08-12T13:02:04.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 833.3333333333334, "createdAt": "2021-08-12T13:04:01.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 559.1666666666666, "createdAt": "2021-08-12T13:05:01.000Z", "group": null, __typename: "BucketMeasurement" }, { "measurement": 400.55555555555554, "createdAt": "2021-08-12T13:10:01.000Z", "group": null, __typename: "BucketMeasurement" }], __typename: "Metric" }, "type": "number", "style": "blue", "scale": 0, "prefix": null, "suffix": null, __typename: "Widget" }, "options": { "currencySymbol": "£" } },
  caseConfigCaseType: {
    id: 1,
    displayName: "Case One",
    name: "caseOne",
    code: "case-one",
    description: "Test caseType 1.",
    iconCode: "folder",
    iconSet: "fal",
    defaultOwnerTeamId: 7,
    teams: [7, 8, 12, 19],
    currentSchema: {
      name: "caseOne",
      case_data_views: {
        detail: {},
        edit: {},
        new: {}
      },
      events: null,
      fieldsets: [{
        name: "f1",
        fields: []
      }, {
        name: "f2",
        fields: []
      }, {
        name: "complaint",
        fields: []
      }]
    },
    displayFields: [{
      id: 8,
      position: 0,
      fieldset: "complaint",
      field: "complaint_ref"
    }],
    statuses: [{
      id: 2,
      position: 2,
      state: "Old"
    }, {
      id: 1,
      position: 1,
      state: "New"
    }],
    tasklistTemplates: [{
      id: 1,
      name: "TasklistTest",
      position: 0,
      tasks: [{
        id: 1,
        description: "test1",
        guidance: "testing",
        actionType: "ModifyCaseActionTask",
        parameters: [],
        actionDefinition: "---",
        position: 0
      },
      {
        id: 2,
        description: "test2",
        guidance: "testing",
        actionType: "ModifyCaseActionTask",
        parameters: [],
        actionDefinition: "---",
        position: 1
      },
      {
        id: 3,
        description: "test3",
        guidance: "testing",
        actionType: "ModifyCaseActionTask",
        parameters: [],
        actionDefinition: "---",
        position: 2
      }
      ]
    },
    {
      id: 2,
      name: "Other TasklistTest",
      position: 1,
      tasks: [{
        id: 4,
        description: "test4",
        guidance: "testing",
        actionType: "ModifyCaseActionTask",
        parameters: [],
        actionDefinition: "---",
        position: 0
      },
      {
        id: 5,
        description: "test5",
        guidance: "testing",
        actionType: "ModifyCaseActionTask",
        parameters: [],
        actionDefinition: "---",
        position: 1
      },
      {
        id: 6,
        description: "test6",
        guidance: "testing",
        actionType: "ModifyCaseActionTask",
        parameters: [],
        actionDefinition: "---",
        position: 2
      }
      ]
    }
    ],
    coreTemplate: true,
    resources: [{
      id: 100,
      name: "Access",
      permissionType: "yes_no",
      resourceType: "case"
    },
    {
      id: 101,
      name: "Access",
      permissionType: "yes_no",
      resourceType: "case"
    },
    {
      id: 102,
      name: "Create",
      permissionType: "yes_no",
      resourceType: "case"
    },
    {
      id: 103,
      name: "Data1",
      permissionType: "read_write_hidden",
      resourceType: "case"
    },
    {
      id: 104,
      name: "Data2",
      permissionType: "read_write_hidden",
      resourceType: "case"
    },
    {
      id: 105,
      name: "Data3",
      permissionType: "read_write_hidden",
      resourceType: "case"
    },
    {
      id: 106,
      name: "Task1",
      permissionType: "read_write_hidden",
      resourceType: "tasklist"
    },
    {
      id: 107,
      name: "Task2",
      permissionType: "read_write_hidden",
      resourceType: "tasklist"
    },
    {
      id: 108,
      name: "Task3",
      permissionType: "read_write_hidden",
      resourceType: "tasklist"
    }
    ],
    relationships: [{
      id: 8,
      position: 0,
      fromFieldsetKey: "references",
      fromRelationKey: "customer_ref",
      fromId: 4,
      toFieldsetKey: "references",
      toRelationKey: "customer_ref",
      toId: 1,
      fields: [{
        id: 1,
        fieldName: "title"
      }],
      key: "test-1"
    }],
    emailTemplates: [{
      id: 11,
      name: "CaseType Response",
      category: "caseType",
      template: "lorem"
    }, {
      id: 11,
      name: "CaseType Response",
      category: "caseType",
      template: "lorem"
    }, {
      id: 11,
      name: "CaseType Response",
      category: "caseType",
      template: "lorem"
    }, {
      id: 11,
      name: "CaseType Response",
      category: "caseType",
      template: "lorem"
    }],
    permissions: [{
      id: 154,
      permissionFlag: "yes",
      resource: {
        id: 100,
        name: "Access",
        permissionType: "yes_no",
        resourceType: "case"
      },
      team: {
        id: 1
      }
    },
    {
      id: 155,
      permissionFlag: "yes",
      resource: {
        id: 101,
        name: "Access",
        permissionType: "yes_no",
        resourceType: "case"
      },
      team: {
        id: 2
      }
    },
    {
      id: 156,
      permissionFlag: "yes",
      resource: {
        id: 102,
        name: "Create",
        permissionType: "yes_no",
        resourceType: "case"
      },
      team: {
        id: 2
      }
    },
    {
      id: 157,
      permissionFlag: "",
      resource: {
        id: 103,
        name: "Data1",
        permissionType: "read_write_hidden",
        resourceType: "case"
      },
      team: {
        id: 1
      }
    },
    {
      id: 158,
      permissionFlag: "r",
      resource: {
        id: 104,
        name: "Data2",
        permissionType: "read_write_hidden",
        resourceType: "case"
      },
      team: {
        id: 1
      }
    },
    {
      id: 159,
      permissionFlag: "w",
      resource: {
        id: 105,
        name: "Data3",
        permissionType: "read_write_hidden",
        resourceType: "case"
      },
      team: {
        id: 1
      }
    },
    {
      id: 160,
      permissionFlag: "",
      resource: {
        id: 106,
        name: "Task1",
        permissionType: "read_write_hidden",
        resourceType: "tasklist"
      },
      team: {
        id: 1
      }
    },
    {
      id: 161,
      permissionFlag: "r",
      resource: {
        id: 107,
        name: "Task2",
        permissionType: "read_write_hidden",
        resourceType: "tasklist"
      },
      team: {
        id: 1
      }
    },
    {
      id: 162,
      permissionFlag: "w",
      resource: {
        id: 108,
        name: "Task3",
        permissionType: "read_write_hidden",
        resourceType: "tasklist"
      },
      team: {
        id: 1
      }
    }
    ],
    questionSets: [],
    scripts: [{
      id: 1,
      name: "Script1",
      description: "Test Script",
      draftCode: "draftCode",
      draftDocument: "{'title':'Script1'}",
      isMicroService: false,
      isReusable: true,
      publishedCode: "exit(payload);",
      updatedAt: "2019-06-10T09:19:06.000Z"
    },
    {
      id: 2,
      name: "Script2",
      description: "Test Script",
      draftCode: "draftCode",
      draftDocument: "{'title':'Script2'}",
      isMicroService: true,
      isReusable: false,
      publishedCode: "exit(payload);",
      updatedAt: "2019-06-11T13:04:43.000Z"
    },
    {
      id: 3,
      name: "preCreate",
      description: "Test LifeCycle",
      draftCode: "draftCode",
      draftDocument: "{'title':'preCreate'}",
      isMicroService: false,
      isReusable: false,
      publishedCode: "exit(payload);",
      updatedAt: "2019-06-10T09:19:06.000Z"
    },
    {
      id: 4,
      name: "preSave",
      description: "Test LifeCycle",
      draftCode: "draftCode",
      draftDocument: "{'title':'preSave'}",
      isMicroService: false,
      isReusable: false,
      publishedCode: "exit(payload);",
      updatedAt: "2019-06-11T13:05:05.000Z"
    }
    ]
  },
  fieldData: {
    richTextField: {
      name: "RichTextField",
      default_value: "DEFAULT TEXT"
    },
    richTextData: "RICH TEXT DATARICH TEXT DATARICH TEXT DATARICH TEXT DATARICH TEXT DATARICH TEXT DATARICH TEXT DATARICH TEXT DATARICH TEXT DATARICH TEXT DATARICH TEXT DATARICH TEXT DATARICH TEXT DATARICH TEXT DATARICH TEXT DATARICH TEXT DATARICH TEXT DATA",
    textInputField: {
      name: "TextInputField",
      default_value: "DEFAULT TEXT"
    },
    textInputData: "TEXT INPUT DATA ",
    textAreaField: {
      name: "TextAreaField",
      default_value: "DEFAULT TEXT"
    },
    textAreaData: "TEXT AREA DATA",
    currencyField: {
      name: "CurrencyField",
      symbol: "£"
    },
    currencyData: 59.99,
    numberField: {
      name: "NumberField",
      default_value: 0
    },
    numberData: 123456789,
    checkboxField: {
      name: "CheckboxField",
      default_value: false
    },
    checkboxData: true,
    selectData: "two",
    booleanField: {
      name: "BooleanField",
      default_value: false
    },
    booleanData: true,
    addressField: {
      name: "AddressField",
      default_value: ""
    },
    addressData: "29 Fake St",
    dateField: {
      name: "DateField"
    },
    dateData: "2019-12-23T08:05:23.731Z",
    relationField: {
      name: "RelationField",
      relation: "case",
      type: "relation"
    },
    relationData: {
      id: 1
    },
    documentField: {
      name: "DocumentField"
    },
    documentData: {
      contentType: "application/pdf",
      extension: "pdf",
      filename: "document.pdf",
      size: "433994",
      status: null,
      createdAt: "2019-02-12T10:57:09.080Z",
      updatedAt: "2019-02-12T10:57:09.080Z",
      url: "/documents/1/13/5c5b136e2e1fc6059ad79a73/pdf.pdf",
      used_as_attachment: false
    },
    embeddedTableField: {
      name: "EmbeddedTableField",
      cardinality: "oneToMany",
      display_name: "Embedded Table Field",
      fields: [{
        name: "row1",
        type: "string"
      },
      {
        name: "row2",
        type: "string"
      },
      {
        name: "row4",
        type: "number",
        display: "currency",
        symbol: "£"
      },
      {
        name: "row5",
        type: "document"
      },
      {
        name: "row3",
        type: "date"
      }

      ]
    },
    embeddedTableData: [{
      row1: "STRING1",
      row2: "STRING2",
      row3: "2019-02-12T10:57:09.080Z",
      row4: 504,
      row5: true
    },
    {
      row1: "STRING1",
      row2: "STRING2",
      row3: "2019-02-12T10:57:09.080Z",
      row4: 504,
      row5: true
    },
    {
      row1: "STRING1",
      row2: "STRING2",
      row3: "2019-02-12T10:57:09.080Z",
      row4: 504,
      row5: true
    },
    {
      row1: "STRING1",
      row2: "STRING2",
      row3: "2019-02-12T10:57:09.080Z",
      row4: 504,
      row5: true
    },
    {
      row1: "STRING1",
      row2: "STRING2",
      row3: "2019-02-12T10:57:09.080Z",
      row4: 504,
      row5: true
    }
    ]
  },
  fileAttachments: [{
    contentType: "image/png",
    extension: "png",
    filename: "Test File 001",
    id: "5d63aab62e1fc623b4000001",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20001.png?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20001.png"
  },
  {
    contentType: "application/pdf",
    extension: "pdf",
    filename: "Test File 002.pdf",
    id: "5d64e65c2e1fc623b4000003",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20002.pdf?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20002.pdf"
  },
  {
    contentType: "image/jpg",
    extension: "jpg",
    filename: "Test File 003",
    id: "5d64e69d2e1fc623b4000004",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20003.jpg?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20003.jpg"
  },
  {
    contentType: "image/png",
    extension: "png",
    filename: "Test File 004",
    id: "5d63aab62e1fc623b4000001",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20004.png?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20004.png"
  },
  {
    contentType: "application/pdf",
    extension: "pdf",
    filename: "Test File 002.pdf",
    id: "5d64e65c2e1fc623b4000005",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20005.pdf?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20005.pdf"
  },
  {
    contentType: "image/jpg",
    extension: "jpg",
    filename: "Test File 006",
    id: "5d64e69d2e1fc623b4000004",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20006.jpg?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20006.jpg"
  },
  {
    contentType: "image/png",
    extension: "png",
    filename: "Test File 007",
    id: "5d63aab62e1fc623b4000001",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20007.png?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20007.png"
  },
  {
    contentType: "application/pdf",
    extension: "pdf",
    filename: "Test File 002.pdf",
    id: "5d64e65c2e1fc623b4000008",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20008.pdf?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20008.pdf"
  },
  {
    contentType: "image/jpg",
    extension: "jpg",
    filename: "Test File 003",
    id: "5d64e69d2e1fc623b4000009",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20009.jpg?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20009.jpg"
  },
  {
    contentType: "image/png",
    extension: "png",
    filename: "Test File 001",
    id: "5d63aab62e1fc623b4000001",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20001.png?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20001.png"
  },
  {
    contentType: "application/pdf",
    extension: "pdf",
    filename: "Test File 002.pdf",
    id: "5d64e65c2e1fc623b4000003",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20002.pdf?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20002.pdf"
  },
  {
    contentType: "image/jpg",
    extension: "jpg",
    filename: "Test File 003",
    id: "5d64e69d2e1fc623b4000004",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20003.jpg?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20003.jpg"
  },
  {
    contentType: "image/png",
    extension: "png",
    filename: "Test File 004",
    id: "5d63aab62e1fc623b4000001",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20004.png?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20004.png"
  },
  {
    contentType: "application/pdf",
    extension: "pdf",
    filename: "Test File 002.pdf",
    id: "5d64e65c2e1fc623b4000005",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20005.pdf?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20005.pdf"
  },
  {
    contentType: "image/jpg",
    extension: "jpg",
    filename: "Test File 006",
    id: "5d64e69d2e1fc623b4000004",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20006.jpg?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20006.jpg"
  },
  {
    contentType: "image/png",
    extension: "png",
    filename: "Test File 007",
    id: "5d63aab62e1fc623b4000001",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20007.png?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20007.png"
  },
  {
    contentType: "application/pdf",
    extension: "pdf",
    filename: "Test File 002.pdf",
    id: "5d64e65c2e1fc623b4000008",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20008.pdf?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20008.pdf"
  },
  {
    contentType: "image/jpg",
    extension: "jpg",
    filename: "Test File 003",
    id: "5d64e69d2e1fc623b4000009",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20009.jpg?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20009.jpg"
  },
  {
    contentType: "image/png",
    extension: "png",
    filename: "Test File 001",
    id: "5d63aab62e1fc623b4000001",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20001.png?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20001.png"
  },
  {
    contentType: "application/pdf",
    extension: "pdf",
    filename: "Test File 002.pdf",
    id: "5d64e65c2e1fc623b4000003",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20002.pdf?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20002.pdf"
  },
  {
    contentType: "image/jpg",
    extension: "jpg",
    filename: "Test File 003",
    id: "5d64e69d2e1fc623b4000004",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20003.jpg?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20003.jpg"
  },
  {
    contentType: "image/png",
    extension: "png",
    filename: "Test File 004",
    id: "5d63aab62e1fc623b4000001",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20004.png?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20004.png"
  },
  {
    contentType: "application/pdf",
    extension: "pdf",
    filename: "Test File 002.pdf",
    id: "5d64e65c2e1fc623b4000005",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20005.pdf?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20005.pdf"
  },
  {
    contentType: "image/jpg",
    extension: "jpg",
    filename: "Test File 006",
    id: "5d64e69d2e1fc623b4000004",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20006.jpg?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20006.jpg"
  },
  {
    contentType: "image/png",
    extension: "png",
    filename: "Test File 007",
    id: "5d63aab62e1fc623b4000001",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20007.png?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d63aab62e1fc623b4000001/Test%20File%20007.png"
  },
  {
    contentType: "application/pdf",
    extension: "pdf",
    filename: "Test File 002.pdf",
    id: "5d64e65c2e1fc623b4000008",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20008.pdf?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e65c2e1fc623b4000003/Test%20File%20008.pdf"
  },
  {
    contentType: "image/jpg",
    extension: "jpg",
    filename: "Test File 003",
    id: "5d64e69d2e1fc623b4000009",
    pages: [{
      pageNo: 0,
      url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20009.jpg?ignoreOnTimeline=true"
    }],
    size: 239,
    uploadedAt: "2019-08-26T09:00:00.000",
    url: "/documents/1/2/5d64e69d2e1fc623b4000004/Test%20File%20009.jpg"
  }
  ],
  caseData: {
    id: "5c5da82b2e1fc6059ad79fee",
    caseTypeId: 20,
    caseType: "Benefit",
    title: "Test Benefit 01",
    currentState: "Not Started",
    notes: [{
      id: 1,
      subject: "Test note 1",
      body: "Hello Notes!",
      editing: false,
      author: {
        id: 1,
        displayName: "Admin"
      },
      createdAt: "2020-03-25T10:47:12.000Z",
      updatedAt: "2020-03-25T10:47:12.000Z"
    },
    {
      id: 2,
      subject: "Test note 2",
      body: "Another note...",
      editing: false,
      author: {
        id: 1,
        displayName: "Admin"
      },
      createdAt: "2020-03-25T10:47:12.000Z",
      updatedAt: "2020-03-25T10:47:12.000Z"
    },
    {
      id: 3,
      subject: "Test note 3",
      body: "Bunch of random text added to fill out the note. Bunch of random text added to fill out the note. Bunch of random text added to fill out the note. ",
      editing: false,
      author: {
        id: 1,
        displayName: "Admin"
      },
      createdAt: "2020-03-25T10:47:12.000Z",
      updatedAt: "2020-03-25T10:47:12.000Z"
    }
    ],
    tasklists: [{
      id: 1,
      name: "Tasklist Name",
      position: 0,
      tasks: [{
        id: 1,
        name: "Task001",
        description: "Test Task 1",
        assignedToTeam: {
          id: 1
        },
        assignedToUser: {
          id: 1
        }
      },
      {
        id: 1,
        name: "Task002",
        description: "Test Task 2",
        assignedToTeam: {
          id: 1
        }
      },
      {
        id: 1,
        name: "Automated Task",
        description: "Test Task 3",
        scheduledType: "by",
        scheduledTime: new Date().setHours(new Date().getHours() + 36),
        task: {
          actionType: "Automatic"
        },
        assignedToTeam: {
          id: 1
        }
      },
      {
        id: 1,
        name: "Scheduled Task",
        description: "Test Task 4",
        scheduledType: "at",
        scheduledTime: new Date(),
        assignedToTeam: {
          id: 1
        }
      }
      ]
    },
    {
      id: 1,
      name: "Tasklist Name Two",
      position: 1,
      tasks: [{
        id: 1,
        name: "Activate",
        description: "Sets the cases current state to active."
      },
      {
        id: 1,
        name: "Deactive",
        description: "Sets the cases current state to inactive."
      },
      {
        id: 1,
        name: "Referr",
        description: "Sets the cases current state to referred."
      },
      {
        id: 1,
        name: "Flag",
        description: "Sets the cases current state to flagged."
      }
      ]
    },
    {
      id: 1,
      name: "Admin",
      position: 2,
      tasks: [{
        id: 8,
        name: "Delete Case",
        description: "Deletes the case."
      }]
    }
    ],
    properties: {
      benefit_ref: 1,
      coverage: "IP",
      code: "TB01-IP",
      schema_version: 1,
      owner_name: "Andrew",
      owned_by_id: 11,
      owned_by_type: "CaseBlocks::User",
      version: 1,
      collection: null,
      tasklistTemplates: [],
      tasks: [],
      id: "5c5da82b2e1fc6059ad79fee"
    },
    fileAttachments: [{
      id: 1,
      filename: "Document",
      extension: "doc",
      url: "/",
      readonly: false,
      isAttachment: false,
      pages: 1,
      size: 100,
      status: "ready",
      uploadedAt: "2019"
    },
    {
      id: 2,
      filename: "Png Picture",
      extension: "png",
      url: "/",
      readonly: false,
      isAttachment: false,
      pages: 1,
      size: 100,
      status: "ready",
      uploadedAt: "2019"
    },
    {
      id: 3,
      filename: "Digital Book",
      extension: "pdf",
      url: "/",
      readonly: false,
      isAttachment: false,
      pages: 1,
      size: 100,
      status: "ready",
      uploadedAt: "2019"
    },
    {
      id: 4,
      filename: "Document 2",
      extension: "odt",
      url: "/",
      readonly: false,
      isAttachment: false,
      pages: 1,
      size: 100,
      status: "ready",
      uploadedAt: "2019"
    },
    {
      id: 5,
      filename: "Zip Archive",
      extension: "zip",
      url: "/",
      readonly: false,
      isAttachment: false,
      pages: 1,
      size: 100,
      status: "ready",
      uploadedAt: "2019"
    },
    {
      id: 6,
      filename: "Jpeg Image",
      extension: "jpg",
      url: "/",
      readonly: false,
      isAttachment: false,
      pages: 1,
      size: 100,
      status: "ready",
      uploadedAt: "2019"
    },
    {
      id: 7,
      filename: "Document 3",
      extension: "txt",
      url: "/",
      readonly: false,
      isAttachment: false,
      pages: 1,
      size: 100,
      status: "ready",
      uploadedAt: "2019"
    },
    {
      id: 8,
      filename: "Web Document",
      extension: "html",
      url: "/",
      readonly: false,
      isAttachment: false,
      pages: 1,
      size: 100,
      status: "ready",
      uploadedAt: "2019"
    },
    {
      id: 9,
      filename: "Spreadsheet",
      extension: "xls",
      url: "/",
      readonly: false,
      isAttachment: false,
      pages: 1,
      size: 100,
      status: "ready",
      uploadedAt: "2019"
    },
    {
      id: 10,
      filename: "Open Spreadsheet",
      extension: "ods",
      url: "/",
      readonly: false,
      isAttachment: false,
      pages: 1,
      size: 100,
      status: "ready",
      uploadedAt: "2019"
    },
    {
      id: 11,
      filename: "Presentation",
      extension: "ppt",
      url: "/",
      readonly: false,
      isAttachment: false,
      pages: 1,
      size: 100,
      status: "ready",
      uploadedAt: "2019"
    }

    ],
    conversations: [{
      id: 1,
      subject: "User correspondence",
      messages: [{
        id: 2,
        createdAt: "0019",
        recipients: [{
          id: 1,
          email: "JohnTester@TestData.com",
          displayName: "John Tester",
          type: "Users"
        }],
        body: "Test message 2, test message 2, test messsage 2",
        from: {
          id: 2,
          displayName: "Jill Tester",
          email: "JillTester@TestData.com",
          avatarUrl: "/",
          type: "Users"
        },
        attachments: []
      }]
    },

    {
      id: 2,
      subject: "Team notices",
      messages: [{
        id: 3,
        createdAt: "0017",
        recipients: [{
          id: 3,
          email: "T-TWO@Testers.com",
          displayName: "Team Two",
          type: "Teams"
        }],
        body: "Test message 1, test message 1, test messsage 1",
        from: {
          id: 1,
          displayName: "John Tester",
          email: "JohnTester@TestData.com",
          avatarUrl: "/",
          type: "Users"
        },
        attachments: []
      }, {
        id: 4,
        createdAt: "0016",
        recipients: [{
          id: 4,
          email: "T-ONE@Testers.com",
          displayName: "Team One",
          type: "Teams"
        }],
        body: "Test message 2, test message 2, test messsage 2",
        from: {
          id: 2,
          displayName: "Jill Tester",
          email: "JillTester@TestData.com",
          avatarUrl: "/",
          type: "Users"
        },
        attachments: []
      }, {
        id: 4,
        createdAt: "0014",
        recipients: [{
          id: 4,
          email: "T-ONE@Testers.com",
          displayName: "Team One",
          type: "Teams"
        }],
        body: "Test message 3, test message 3, test messsage 3",
        from: {
          id: 2,
          displayName: "Jill Tester",
          email: "JillTester@TestData.com",
          avatarUrl: "/",
          type: "Users"
        },
        attachments: []
      }]
    },
    {
      id: 3,
      subject: "Support Requests",
      messages: [{
        id: 5,
        createdAt: "0015",
        recipients: [{
          id: 3,
          email: "customIndividual1@Testers.com",
          displayName: "Team Two",
          type: "custom"
        }],
        body: "Test message 1, test message 1, test messsage 1",
        from: {
          id: 1,
          displayName: "John Tester",
          email: "JohnTester@TestData.com",
          avatarUrl: "/",
          type: "Users"
        },
        attachments: []
      }]
    },
    {
      id: 3,
      subject: "External Emails ",
      messages: [{
        id: 5,
        createdAt: "0015",
        recipients: [{
          id: 3,
          email: "customIndividual1@Testers.com",
          displayName: "Team Two",
          type: "custom"
        }],
        body: "Test message 1, test message 1, test messsage 1",
        from: {
          id: 1,
          displayName: "John Tester",
          email: "JohnTester@TestData.com",
          avatarUrl: "/",
          type: "Users"
        },
        attachments: []
      }]
    },
    {
      id: 3,
      subject: "Enquiries",
      messages: [{
        id: 5,
        createdAt: "0015",
        recipients: [{
          id: 3,
          email: "customIndividual1@Testers.com",
          displayName: "Team Two",
          type: "custom"
        }],
        body: "Test message 1, test message 1, test messsage 1",
        from: {
          id: 1,
          displayName: "John Tester",
          email: "JohnTester@TestData.com",
          avatarUrl: "/",
          type: "Users"
        },
        attachments: []
      }]
    }
    ],
    createdAt: "2019-02-08T16:02:51.409Z",
    updatedAt: "2019-02-08T16:02:51.409Z",
    schema: {
      name: "Benefit",
      events: null,
      case_data_views: {
        new: {
          rows: [{
            columns: [{
              fieldset: "details"
            }]
          }]
        },
        edit: {
          rows: [{
            columns: [{
              fieldset: "details"
            }]
          },
          {
            columns: [{
              fieldset: "internal_references"
            }]
          }
          ]
        },
        detail: {
          rows: [{
            columns: [{
              fieldset: "details"
            }]
          }]
        }
      },
      fieldsets: [{
        name: "internal_references",
        fields: [{
          name: "benefit_ref",
          type: "number",
          size: null,
          display_name: null,
          guidance: null,
          default_value: null,
          format: null,
          readonly: true,
          required: null,
          display: null,
          symbol: null,
          cardinality: null,
          item_type: null,
          dependent_on: null,
          formula: null,
          validation: null,
          validation_message: null,
          options: null,
          cascading_parent_field: null,
          uif: null,
          relation: null,
          cascading_options: null,
          fields: null
        }]
      },
      {
        name: "details",
        fields: [{
          name: "title",
          type: "string",
          size: null,
          display_name: "Title",
          guidance: null,
          default_value: null,
          format: null,
          readonly: null,
          required: true,
          display: null,
          symbol: null,
          cardinality: null,
          item_type: null,
          dependent_on: null,
          formula: null,
          validation: null,
          validation_message: null,
          options: null,
          cascading_parent_field: null,
          uif: null,
          relation: null,
          cascading_options: null,
          fields: null
        },
        {
          name: "coverage",
          type: "string",
          size: null,
          display_name: null,
          guidance: null,
          default_value: null,
          format: null,
          readonly: null,
          required: true,
          display: "select",
          symbol: null,
          cardinality: null,
          item_type: null,
          dependent_on: null,
          formula: null,
          validation: null,
          validation_message: null,
          options: [
            "IP",
            "OP",
            "EXT",
            "PHAR",
            "DEN",
            "WP",
            "DD",
            "MAT",
            "SMM"
          ],
          cascading_parent_field: null,
          uif: null,
          relation: null,
          cascading_options: null,
          fields: null
        },
        {
          name: "code",
          type: "string",
          size: null,
          display_name: null,
          guidance: null,
          default_value: null,
          format: null,
          readonly: null,
          required: null,
          display: null,
          symbol: null,
          cardinality: null,
          item_type: null,
          dependent_on: null,
          formula: null,
          validation: null,
          validation_message: null,
          options: null,
          cascading_parent_field: null,
          uif: null,
          relation: null,
          cascading_options: null,
          fields: null
        }
        ]
      }
      ]
    }
  },
  userTimelineData: [{
    date: "2018-11-19",
    events: [{
      id: "5bf29e1989bce24361000006",
      title: "Miss Joesph Hirthe",
      activity: "case.read",
      createdAt: "2018-11-19T11:27:21.665Z",
      causedBy: {
        id: 5,
        displayName: "Ijonas"
      },
      caseId: "5bbe0e9989bce24d00000005",
      caseType: {
        id: 7,
        name: "Supplier Contact"
      },
      params: null
    },
    {
      id: "5bf29e1189bce24361000005",
      title: "Ms. Colten Kris",
      activity: "case.read",
      createdAt: "2018-11-19T11:27:13.569Z",
      causedBy: {
        id: 5,
        displayName: "Ijonas"
      },
      caseId: "5bbe0e9c89bce24d00000090",
      caseType: {
        id: 5,
        name: "Customer"
      },
      params: null
    },
    {
      id: "5bf29e0789bce24361000003",
      title: "Miss Pat Dach",
      activity: "case.read",
      createdAt: "2018-11-19T11:27:03.140Z",
      causedBy: {
        id: 5,
        displayName: "Ijonas"
      },
      caseId: "5bbe0e9989bce24d00000009",
      caseType: {
        id: 7,
        name: "Supplier Contact"
      },
      params: null
    },
    {
      id: "5bf29dfd89bce24360000003",
      title: "Ms. Colten Kris",
      activity: "case.read",
      createdAt: "2018-11-19T11:26:53.602Z",
      causedBy: {
        id: 5,
        displayName: "Ijonas"
      },
      caseId: "5bbe0e9c89bce24d00000090",
      caseType: {
        id: 5,
        name: "Customer"
      },
      params: null
    },
    {
      id: "5bf29df589bce24360000001",
      title: "Claim 13-003",
      activity: "case.read",
      createdAt: "2018-11-19T11:26:45.004Z",
      causedBy: {
        id: 5,
        displayName: "Ijonas"
      },
      caseId: "5bbe0e9c89bce24d00000086",
      caseType: {
        id: 2,
        name: "Claim"
      },
      params: null
    }
    ]
  }],

  currentlySelectedUser: {
    id: 4,
    displayName: "Stewart Campbell",
    login: "stewart@emergeadapt.local",
    email: "stewart@emergeadapt.local",
    lastSeen: "Thu Dec 06 2018 15:54:45 GMT+0000 (GMT)",
    authenticationToken: "123456789",
    isAccountAdmin: true,
    avatarUrl: "/users/avatar/1/4/test-avatar.jpg",
    teams: [{
      id: 6,
      displayName: "Specialist Uplift Team",
      users: []
    },
    {
      id: 3,
      displayName: "Claims Team",
      users: []
    }
    ],
    preferences: {
      dateFormat: "Do MMM YYYY",
      dateTimeFormat: "Do MMM YYYY, HH:mm"
    }
  },
  manyUsers: [{
    id: 1,
    displayName: "Test User 1",
    email: "fake1@user.com",
    last_seen: "2018-09-04T10:11:10.000Z",
    created_at: "2016-04-08T08:00:00.000Z",
    avatar_url: "https://randomuser.me/api/portraits/men/11.jpg"
  },
  {
    id: 2,
    displayName: "Test User 2",
    email: "fake2@user.com",
    last_seen: "2018-09-02T15:19:08.000Z",
    created_at: "2016-04-14T08:00:00.000Z",
    avatar_url: "https://randomuser.me/api/portraits/men/1.jpg"
  },
  {
    id: 3,
    displayName: "Test User 3",
    email: "fake4@user.com",
    last_seen: "2018-09-03T11:49:22.000Z",
    created_at: "2016-04-02T08:00:00.000Z",
    avatar_url: "https://randomuser.me/api/portraits/men/5.jpg"
  },
  {
    id: 4,
    displayName: "Test User 4",
    email: "fake5@user.com",
    last_seen: "2018-09-04T18:02:13.000Z",
    created_at: "2016-04-22T08:00:00.000Z",
    avatar_url: "https://randomuser.me/api/portraits/men/7.jpg"
  },
  {
    id: 5,
    displayName: "Test User 5",
    email: "fake6@user.com",
    last_seen: "2018-09-01T08:41:32.000Z",
    created_at: "2016-04-17T08:00:00.000Z",
    avatar_url: ""
  }
  ],
  currentViewers: [{
    name: "Huey Duck",
    userId: 1
  }, {
    name: "Duey D.",
    userId: 2
  }, {
    name: "Louie",
    userId: 3
  }],
  manySmallTeams: [{
    displayName: "Test Team 1",
    updated_at: "2016-02-14T19:27:28.000Z",
    created_at: "2016-01-01T08:02:53.000Z",
    users: [{
      id: 1,
      displayName: "Test User 1",
      last_seen: "2016-02-14T19:27:28.000Z",
      created_at: "2016-01-01T08:02:53.000Z",
      avatar_url: "none"
    }]
  },
  {
    displayName: "Test Team 2",
    updated_at: "2016-02-15T19:27:28.000Z",
    created_at: "2016-01-03T08:02:53.000Z",
    members: [{
      displayName: "Jimmy",
      last_seen: "2016-02-16T19:27:28.000Z",
      created_at: "2016-01-04T08:02:53.000Z",
      avatar_url: "none"
    }]
  },
  {
    displayName: "Test Team 3",
    updated_at: "2016-02-17T19:27:28.000Z",
    created_at: "2016-01-05T08:02:53.000Z",
    members: [{
      displayName: "Fred",
      last_seen: "2016-02-18T19:27:28.000Z",
      created_at: "2016-01-06T08:02:53.000Z",
      avatar_url: "none"
    },
    {
      displayName: "Greg",
      last_seen: "2016-02-19T19:27:28.000Z",
      created_at: "2016-01-07T08:02:53.000Z",
      avatar_url: "none"
    }
    ]
  },
  {
    displayName: "Test Team 4",
    updated_at: "2016-02-20T19:27:28.000Z",
    created_at: "2016-01-08T08:02:53.000Z",
    members: [{
      displayName: "Nigel",
      last_seen: "2016-02-21T19:27:28.000Z",
      created_at: "2016-01-09T08:02:53.000Z",
      avatar_url: "none"
    }]
  },
  {
    displayName: "Test Team 5",
    updated_at: "2016-02-22T19:27:28.000Z",
    created_at: "2016-01-10T08:02:53.000Z",
    members: [{
      displayName: "Jimmy",
      last_seen: "2016-02-23T19:27:28.000Z",
      created_at: "2016-01-11T08:02:53.000Z",
      avatar_url: "none"
    }]
  },
  {
    displayName: "Test Team 6",
    updated_at: "2016-02-24T19:27:28.000Z",
    created_at: "2016-01-12T08:02:53.000Z",
    members: [{
      displayName: "Fred",
      last_seen: "2016-02-25T19:27:28.000Z",
      created_at: "2016-01-13T08:02:53.000Z",
      avatar_url: "none"
    },
    {
      displayName: "Greg",
      last_seen: "2016-02-02T19:27:28.000Z",
      created_at: "2016-01-04T08:02:53.000Z",
      avatar_url: "none"
    }
    ]
  },
  {
    displayName: "Searchable Team 7",
    updated_at: "2016-01-15T19:27:28.000Z",
    created_at: "2016-01-03T08:02:53.000Z",
    members: [{
      displayName: "Nigel",
      last_seen: "2016-01-16T19:27:28.000Z",
      created_at: "2016-01-10T08:02:53.000Z",
      avatar_url: "none"
    }]
  },
  {
    displayName: "Test Team 8",
    updated_at: "2016-01-24T19:27:28.000Z",
    created_at: "2016-01-01T08:02:53.000Z",
    members: [{
      displayName: "Jimmy",
      last_seen: "2016-02-14T19:27:28.000Z",
      created_at: "2016-01-01T08:02:53.000Z",
      avatar_url: "none"
    }]
  },
  {
    displayName: "Searchable Team 9",
    updated_at: "2016-01-11T19:27:28.000Z",
    created_at: "2016-01-01T08:02:53.000Z",
    members: [{
      displayName: "Fred",
      last_seen: "2016-03-16T19:27:28.000Z",
      created_at: "2016-02-05T08:02:53.000Z",
      avatar_url: "none"
    },
    {
      displayName: "Greg",
      last_seen: "2016-02-02T19:27:28.000Z",
      created_at: "2016-01-18T08:02:53.000Z",
      avatar_url: "none"
    }
    ]
  }
  ],
  savedSearches: [{
    id: "1-inbox",
    name: "Default Inbox",
    query: "emailAccountId:1",
    systemProvided: true,
    createdAt: "2020-06-12T10:46:24.000Z",
    updatedAt: "2020-06-12T10:46:24.000Z",
    contents: {
      total: 5,
      messages: [{
        archivedAt: null,
        archivedBy: null,
        attachments: [],
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ultricies felis non elementum ornare. Nulla pharetra ac ipsum sit amet malesuada. Nulla elementum mattis enim, vitae consequat mauris elementum eget. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Quisque molestie, dui nec imperdiet dapibus, enim magna mattis sem, sed efficitur lectus ante non nibh. Quisque condimentum in leo nec lacinia. Ut vitae nibh vel elit fermentum porta. Proin enim dui, lobortis non lacinia ut, sodales at felis. Aenean dui leo, euismod in auctor vitae, ultricies eu erat. Phasellus viverra ac magna vel aliquam. Vestibulum sed sapien nisl. Nam eleifend et mauris non pharetra. Mauris vitae tincidunt ipsum.",
        conversation: {
          id: 1,
          case: {
            id: 3
          }
        },
        from: {
          id: 1,
          displayName: "Sender",
          email: "Sender@test.com",
          type: "user"
        },
        id: "78",
        markedReadAt: null,
        markedReadBy: null,
        recipients: [{
          id: 2,
          displayName: "Recipient"
        }],
        subject: "Lorem ipsum dolor",
        createdAt: "2020-06-19T09:44:46.000Z",
        updatedAt: "2020-06-19T09:44:46.000Z"
      },
      {
        archivedAt: null,
        archivedBy: null,
        attachments: [],
        body: "Sed at vulputate neque, sed lobortis lorem. Aenean urna felis, gravida a tincidunt vitae, dignissim non ex. Donec vel aliquet massa, id luctus nibh. Aliquam tincidunt rhoncus commodo. Fusce fringilla justo ut mi pellentesque, vitae maximus massa scelerisque. Cras iaculis arcu vitae quam vehicula varius. Nunc quis lacus eu nunc vestibulum convallis eu aliquam leo. Vestibulum dignissim sodales purus at pharetra. Nulla vel scelerisque metus. Integer consequat sapien ac velit placerat elementum. Integer a sapien id libero venenatis porta sit amet pretium lectus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Nulla eget diam at metus accumsan lacinia. Sed vel ipsum varius, eleifend dui sit amet, consectetur nibh.",
        conversation: {
          id: 2,
          case: {
            id: 3
          }
        },
        from: {
          id: 1,
          displayName: "Sender",
          email: "Sender@test.com",
          type: "user"
        },
        id: "79",
        markedReadAt: null,
        markedReadBy: null,
        recipients: [{
          id: 2,
          displayName: "Recipient"
        }],
        subject: "Sed at vulputate",
        createdAt: "2020-06-19T09:44:46.000Z",
        updatedAt: "2020-06-19T09:44:46.000Z"
      },
      {
        archivedAt: null,
        archivedBy: null,
        attachments: [],
        body: "Nullam consectetur id erat ut vehicula. Aliquam ut egestas orci. In condimentum consectetur augue eu ultricies. Sed a ultrices lacus, vel pellentesque nulla. Aliquam id volutpat velit, ut tempus orci. Morbi aliquam arcu mauris, in sollicitudin arcu gravida id. Nulla vehicula quis turpis fringilla condimentum. Mauris faucibus, sem eget faucibus blandit, quam arcu maximus augue, ut feugiat risus dolor id felis. Donec a feugiat velit. Nullam quis ante in mi accumsan feugiat ac nec turpis. Etiam feugiat sagittis lacus, in accumsan magna. Etiam ultricies tempor elit, id porttitor neque. In malesuada et lacus sed iaculis. Nam quis ipsum elementum, rutrum arcu auctor, ultricies ligula. Nullam sollicitudin aliquam cursus.",
        conversation: {
          id: 2,
          case: {
            id: 3
          }
        },
        from: {
          id: 1,
          displayName: "Sender",
          email: "Sender@test.com",
          type: "user"
        },
        id: "80",
        markedReadAt: null,
        markedReadBy: null,
        recipients: [{
          id: 2,
          displayName: "Recipient"
        }],
        subject: "Nullam consectetur id",
        createdAt: "2020-06-19T09:44:46.000Z",
        updatedAt: "2020-06-19T09:44:46.000Z"
      },
      {
        archivedAt: null,
        archivedBy: null,
        attachments: [{
          filename: "test.png",
          extension: "png",
          route: "/"
        }],
        body: "Maecenas ac consectetur orci. Morbi eget turpis augue. Morbi id lectus aliquet, condimentum purus sed, ultricies risus. Nullam congue sit amet urna id congue. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum turpis nibh, imperdiet finibus diam vitae, viverra sagittis nulla. Nam interdum convallis erat, in interdum elit varius at. Sed congue elementum orci non viverra. Pellentesque ut nisi nec odio bibendum porta eu ac quam. Sed diam lorem, dignissim quis sagittis non, pellentesque sed ipsum.",
        conversation: {
          id: 2,
          case: {
            id: 3
          }
        },
        from: {
          id: 1,
          displayName: "Sender",
          email: "Sender@test.com",
          type: "user"
        },
        id: "81",
        markedReadAt: null,
        markedReadBy: null,
        recipients: [{
          id: 2,
          displayName: "Recipient"
        }],
        subject: "Maecenas ac consectetur",
        createdAt: "2020-06-19T09:44:46.000Z",
        updatedAt: "2020-06-19T09:44:46.000Z"
      },
      {
        archivedAt: null,
        archivedBy: null,
        attachments: [],
        body: "Nulla quam massa, placerat sit amet porttitor maximus, tristique vitae tellus. Cras gravida vestibulum ligula eget faucibus. Praesent ut fringilla elit, et rhoncus ipsum. Ut auctor porttitor pulvinar. Nunc ac tellus a elit porttitor vestibulum dictum quis nisl. Fusce vestibulum augue quis augue congue rutrum. Aenean sapien ipsum, malesuada in ornare ac, scelerisque pharetra erat. Phasellus eget dapibus metus, eget interdum mauris. Maecenas id pulvinar leo, ut ornare turpis. Suspendisse augue elit, sollicitudin nec ullamcorper nec, suscipit et eros. Nulla ac finibus est, vel aliquet nulla. Nulla laoreet ligula dolor, eget blandit est efficitur eu. Integer quis metus elementum, venenatis velit ut, faucibus tellus. Aenean pharetra fringilla risus, a scelerisque eros vestibulum et.",
        conversation: {
          id: 2,
          case: {
            id: 3
          }
        },
        from: {
          id: 1,
          displayName: "Sender",
          email: "Sender@test.com",
          type: "user"
        },
        id: "82",
        markedReadAt: null,
        markedReadBy: null,
        recipients: [{
          id: 2,
          displayName: "Recipient"
        }],
        subject: "Nulla quam massa",
        createdAt: "2020-06-19T09:44:46.000Z",
        updatedAt: "2020-06-19T09:44:46.000Z"
      }
      ]
    }
  }]
}
